<template>
  <EdroneDrawer :open="open" width="35rem" :without-backdrop="withoutBackdrop" @close="$emit('close')">
    <div class="tw:flex tw:flex-col tw:h-full">
      <EdroneNavigationTop type="drawer" class="tw:flex-shrink-0">
        <template #header>
          <EdroneHeader type="h2" :title="trans._products.content.drawer.headerTitle" />
        </template>
      </EdroneNavigationTop>

      <div class="tw:flex-1 tw:overflow-y-auto tw:p-6">
        <slot />
      </div>

      <EdroneNavigationBottom class="tw:flex-shrink-0">
        <template #start>
          <EdroneButton type="text" unique-id="product-report-drawer-close" @click="$emit('close')">
            {{ trans._readyFlows.smartInsight.drawer.footer.btn.close }}
          </EdroneButton>
        </template>
      </EdroneNavigationBottom>
    </div>
  </EdroneDrawer>
</template>

<script setup lang="ts">
import EdroneDrawer from "edrone-components/EdroneDrawer.vue";
import EdroneHeader from "edrone-components/EdroneHeader.vue";
import EdroneNavigationTop from "edrone-components/EdroneNavigationTop.vue";
import EdroneNavigationBottom from "edrone-components/EdroneNavigationBottom.vue";
import EdroneButton from "edrone-components/EdroneButton.vue";

interface Props {
  open: boolean;
  withoutBackdrop?: boolean;
}

defineProps<Props>();
defineEmits(["close"]);
</script>
